import { UI } from '../UI';

export const bomColumns = [
  //{ data: null, width: 30, defaultContent: '', className: 'control', orderable: false, sortable: false, responsivePriority: 0 },
  {
    title: $Lang.BOM.Articlenumber,
    data: 'articleNumber',
    orderable: false,
    sortable: false,
    className: 'cell-width-250'
  },
  { title: $Lang.BOM.SKUCustomeritemcode, data: 'sku', orderable: false, sortable: false, className: 'cell-width-250' },
  {
    title: $Lang.BOM.AssetArtworkPrintedTrim,
    data: 'artwork',
    orderable: false,
    sortable: false,
    className: 'cell-width-250',
    render: (data) => {
      return `
        <div class="table-thumbnail-wrapper">
            ${UI.thumbnail(data.image)}
            <span class="table-thumbnail-description">${data.name}</span>
        </div>
      `;
    }
  },
  {
    title: $Lang.BOM.BlankModel,
    data: 'blankModel',
    orderable: false,
    sortable: false,
    className: 'dark cell-width-240'
  },
  { title: $Lang.BOM.Color, data: 'color', orderable: false, sortable: false, className: 'dark cell-width-120' },
  { title: $Lang.BOM.Size, data: 'size', orderable: false, sortable: false, className: 'dark cell-width-120' },
  { title: $Lang.BOM.Printpanel, data: 'printPanel', orderable: false, sortable: false, className: 'cell-width-120' },
  {
    title: $Lang.BOM.Printarea,
    data: 'printArea',
    orderable: false,
    sortable: false,
    className: 'dark cell-width-120'
  },
  {
    title: $Lang.BOM.AssetID,
    data: 'artwork.standartId',
    orderable: false,
    sortable: false,
    className: 'dark cell-width-240 fixedWidth',
    render: (data) => {
      return `<span class="nowrap">${data}</span>`;
    }
  },
  {
    title: $Lang.BOM.PrintPallet,
    data: 'artwork.printPallete',
    orderable: false,
    sortable: false,
    className: 'dark cell-width-240'
  },
  {
    title: $Lang.BOM.Packaging,
    data: 'packaging',
    orderable: false,
    sortable: false,
    className: 'dark cell-width-180'
  },
  {
    title: $Lang.BOM.referenceNumber,
    data: 'referenceNumber',
    orderable: false,
    sortable: false,
    className: 'dark cell-width-180'
  },
  {
    title: $Lang.BOM.referenceSticker,
    data: 'referenceSticker',
    orderable: false,
    sortable: false,
    className: 'dark cell-width-180'
  }
];
